import { create } from "zustand";
import { persist } from "zustand/middleware";

// Tri-estado: "", "true", "false" (strings). Evita problemas del <select>.
const initialState = {
  arc: "",
  start_date: "",
  end_date: "",
};

export const useFilterStore = create(
  persist(
    (set) => ({
      filters: initialState,
      setFilter: (key, value) => set((s) => ({ filters: { ...s.filters, [key]: value } })),
      setFilters: (obj) => set((s) => ({ filters: { ...s.filters, ...obj } })),
      resetFilters: () => set({ filters: initialState }),
    }),
    {
      name: "filters-store", // clave en localStorage
    },
  ),
);
